document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-header');
  const hamButton = document.querySelector('.js-hamButton');
  const headerDrawer = document.querySelector('.js-drawer');
  const headerWrapper = document.querySelector('.l-headerWrapper');
  // drawerの中のページ内リンクを全て取得
  const drawerLinks = document.querySelectorAll('.js-drawer a[href^="#"]');

  const scrollThreshold = 400;

  // ヘッダーの高さを取得してCSS変数に設定する関数
  const setHeaderHeight = () => {
    if (headerWrapper) {
      const height = headerWrapper.clientHeight;
      document.documentElement.style.setProperty(
        '--headerHeight',
        `${height}px`
      );
    }
  };

  // ヘッダーが画面内に表示されているかチェックする関数
  const isHeaderVisible = () => {
    if (!header) return false;
    const rect = header.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  };

  // drawerを閉じる関数
  const closeDrawer = () => {
    hamButton?.classList.remove('is-active');
    headerDrawer?.classList.remove('is-active');
  };

  // スクロールハンドラー
  const handleScroll = () => {
    if (!header) return;

    const currentScrollPos = window.scrollY;

    if (currentScrollPos > scrollThreshold) {
      // しきい値を超えた場合は固定表示
      header.classList.add('is-fixed');
      header.classList.remove('is-out');
    } else {
      // しきい値未満の場合
      header.classList.remove('is-fixed');

      if (currentScrollPos === 0 || isHeaderVisible()) {
        // 最上部またはヘッダーが見えている場合はis-outを削除
        header.classList.remove('is-out');
      } else {
        // それ以外の場合はis-outを追加
        header.classList.add('is-out');
      }
    }
  };

  // 初期設定
  setHeaderHeight();

  // イベントリスナーの設定
  window.addEventListener('scroll', () => {
    requestAnimationFrame(handleScroll);
  });

  window.addEventListener('resize', () => {
    setHeaderHeight();
  });

  // ハンバーガーメニューの処理
  hamButton?.addEventListener('click', () => {
    const isActive = hamButton.classList.toggle('is-active');
    headerDrawer?.classList.toggle('is-active');
  });

  // drawer内のリンククリック時の処理を追加
  drawerLinks.forEach((link) => {
    link.addEventListener('click', () => {
      closeDrawer();
    });
  });

  // 初期スクロール位置のチェック
  handleScroll();
});
